module.exports = __webpack_public_path__ + "img/mobile-image.d38ada22.png";